import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AttributeTopBrandsProps {
  scores: Record<string, Record<string, any>>;
  attributes: string[];
  findCompetitorUrl: (brand: string) => string;
  getFavicon: (url: string) => string;
}
const AttributeTopBrands: React.FC<AttributeTopBrandsProps> = ({
  scores,
  attributes,
  findCompetitorUrl,
  getFavicon
}) => {
  const [selectedAttribute, setSelectedAttribute] = useState<string>(attributes.length > 0 ? attributes[0] : '');
  const [showAllBrands, setShowAllBrands] = useState(false);
  // Get score value safely (handles both old and new format)
  const getScore = (brand: string, attribute: string) => {
    const value = scores[brand][attribute];
    if (typeof value === 'number') {
      return value;
    } else if (typeof value === 'object' && value !== null && 'score' in value) {
      return value.score;
    }
    return 0;
  };
  // Get top brands for the selected attribute
  const getTopBrands = (attribute: string, limit: number) => {
    const brandScores = Object.entries(scores).map(([brand, brandScores]) => ({
      brand,
      score: getScore(brand, attribute)
    })).sort((a, b) => b.score - a.score).slice(0, limit);
    return brandScores;
  };
  const topBrands = selectedAttribute ? getTopBrands(selectedAttribute, showAllBrands ? 10 : 5) : [];
  return <div className="w-full" data-id="element-729">
      <div className="mb-6" data-id="element-730">
        <label htmlFor="attribute-select" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-731">
          Selecione um atributo
        </label>
        <div className="relative inline-block w-full max-w-xs" data-id="element-732">
          <select id="attribute-select" value={selectedAttribute} onChange={e => setSelectedAttribute(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-[#1649ff] focus:border-[#1649ff] sm:text-sm rounded-md appearance-none shadow-sm text-gray-900" data-id="element-733">
            {attributes.map(attribute => <option key={attribute} value={attribute} data-id="element-734">
                {attribute}
              </option>)}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-735">
            <ChevronDown className="h-4 w-4 text-gray-400" data-id="element-736" />
          </div>
        </div>
      </div>
      <div className="space-y-4" data-id="element-737">
        {topBrands.map(({
        brand,
        score
      }, index) => <div key={brand} className="flex flex-col" data-id="element-738">
            <div className="flex items-center mb-1" data-id="element-739">
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-gray-100 rounded-full mr-2 text-xs font-bold text-gray-900" data-id="element-740">
                {index + 1}
              </div>
              <img src={getFavicon(findCompetitorUrl(brand))} alt={`${brand} logo`} className="w-5 h-5 mr-2" onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = 'https://www.google.com/s2/favicons?domain=example.com&sz=128';
          }} data-id="element-741" />
              <span className="text-sm font-medium text-gray-900" data-id="element-742">{brand}</span>
              <span className="ml-auto text-sm font-bold text-gray-900" data-id="element-743">
                {score}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-744">
              <div className="h-2.5 rounded-full bg-[#1649ff]" style={{
            width: `${score}%`
          }} data-id="element-745"></div>
            </div>
          </div>)}
        {topBrands.length === 0 && <div className="text-center py-4 text-gray-500" data-id="element-746">
            Não há dados disponíveis para este atributo.
          </div>}
      </div>
      {/* Expand/Collapse button */}
      {Object.keys(scores).length > 5 && <button onClick={() => setShowAllBrands(!showAllBrands)} className="mt-4 text-sm text-gray-500 hover:text-gray-700 flex items-center mx-auto" data-id="element-747">
          {showAllBrands ? <>
              <ChevronUp size={16} className="mr-1" data-id="element-748" />
              Mostrar menos
            </> : <>
              <ChevronDown size={16} className="mr-1" data-id="element-749" />
              Mostrar mais
            </>}
        </button>}
    </div>;
};
export default AttributeTopBrands;